import List from "./List";

const routes = [
    {
        path: 'categories',
        element: <List />
    }
]
export default routes;